import React from 'react';
import {Link} from "umi";
import './index.less'

const downLoadApp = () => {
  const selectItems: FunctionItem[] = [
    {
      id: 'downLoadApp/smartPropertyApp',
      title: '屋托帮物业',
    }
  ];
  return <div className="downLoadApp">
    <div className="item_box">
      {
        selectItems.map((item, index) => (
          <Link className={"text"} to={item.id}>{item.title}</Link>
        ))
      }
    </div>
  </div>;
};

export default downLoadApp;
